export type CognitoAuthChallenge = "NEW_PASSWORD_REQUIRED";

export type AuthChallengeResult = { type: "SUCCESS" } | { type: "NEW_PASSWORD_REQUIRED" };

export const resolveAuthChallenge = async (user: any): Promise<AuthChallengeResult> => {
  if (user?.challengeName === "NEW_PASSWORD_REQUIRED") {
    return { type: "NEW_PASSWORD_REQUIRED" };
  }

  if (user?.challengeName) {
    throw new Error(`Unsupported authentication challenge: ${user.challengeName}`);
  }

  return { type: "SUCCESS" };
};
